import React,{useContext,useEffect, useState, useRef, useMemo, useCallback} from 'react';
import { DatabaseContext } from '../../redux/DatabaseStore';
import { deleteRequest, getRequest, postRequest, tabulatorGet, downloadBlobGet, fetchTextGet } from '../../api/ApiController';
import { InfoIcon, ErrorIcon, TaskIcon, PermissionIcon, NeedIcon, EmergencyIcon,EditRowIcon, DeleteIcon, BorrowItemIcon, UnseenIcon, SeenIcon, TechChangeIcon, RefreshIcon, PrintIcon, ExportIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, SearchIcon } from "../svg/svgIcons";
import AuthContext from '../../components/AuthContext';
import UtilContext from '../../components/UtilContext';
import { confirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import { MdSearch, MdSearchOff } from 'react-icons/md';
import '../../assets/css/support.css'
import { ReactTabulator ,reactFormatter} from 'react-tabulator';
import { Avatar } from 'primereact/avatar';
import { AvatarGroup } from "primereact/avatargroup";
import { DateTime } from "luxon";
import { getTimezone } from '../../utils/moduleSettings';
import { PanelMenu } from 'primereact/panelmenu';
import StatusIndicator, { MachineStateDot, getStatusIndicatorFilterValue } from '../../components/StatusIndicator';
import { extractSafePaginationParams, parseSorters, mergeMaintenanceServiceTaskPagedListFiltersAndSorters, safeParse, sanitizeTabulatorLayoutAttributes, coerceHeaderFilterList, cleanSorters } from '../../utils/tabulatorProgressiveLoading';
import { buildAuditTabulatorColumns, TABULATOR_AUDIT_MIN_ROW_HEIGHT, TABULATOR_AUDIT_PROFILES } from '../../utils/tabulatorAuditColumns';
import {
    appendServiceTaskToolbarSearch,
    createServiceTaskGenerationAwareAjaxRequest,
    serviceTaskRemoteHeaderFilterAlwaysTrue,
} from '../../utils/serviceTaskPrimaryListStandard';
import {
    SERVICE_TASK_LIST_INVALIDATED_EVENT,
    SESSION_INVALIDATING,
    applyPagedMutationOverlay,
    classifyServiceTaskDetailListMutation,
} from '../../utils/serviceTaskListSync';
import { getPusherChannel } from '../../utils/pusherChannel';
import { primeMultiSelectHeaderFilter } from '../../utils/primeMultiSelectHeaderFilter';
import { dateUserHeaderFilter, DATE_USER_HEADER_FILTER_COL_MIN_WIDTH } from '../../utils/dateUserHeaderFilter';
import { inputOnEnterHeaderFilter } from '../../utils/inputOnEnterHeaderFilter';
import { scrollToFirst as scrollToFirstUtil, scrollUp as scrollUpUtil, scrollDown as scrollDownUtil, scrollToLast as scrollToLastUtil } from '../../utils/tabulatorScroll';
import { getTabulatorLayoutForStandardMask } from '../../utils/tabulatorLayoutUtils';
import PrintOptionsDialog from '../../components/PrintOptionsDialog';
import { buildExportQueryStringFromParams, openPrintHtmlWindow, triggerBlobDownload } from '../../utils/serviceTaskExport';
import { getEffectiveMask } from '../../utils/effectiveMask';
import {
    applyServiceTaskSessionSnapshotToExtra,
    resolveServiceTaskListTableBuiltRestore,
    shouldApplySavedMaskOnUnbuiltTable,
} from '../../utils/serviceTaskListMaskRestore';
import { EXPORT_DOCUMENT_TITLE_KEYS, excelSheetTitleFromDocumentTitle, xlsxDownloadFilename } from '../../utils/exportExcelNaming';
import { defaultProductLogoSrc } from '../../constants/brandingDisplay';
import { buildCanonicalPrintFooterHtml, buildCanonicalPrintHeaderHtml } from '../../utils/printChrome';
import { LocaleContext } from '../../components/LocaleContext';
import TabulatorMaskDialog from '../../utils/tabulatorMaskDialog';
import { hasFpCrmDelete } from '../../utils/crmCommunicationPermissions';
import {
    createServiceTaskCrmMergedFetch,
    CRM_TICKET_SOURCE,
    CRM_TOP_TYPE_DROPDOWN_OPTIONS,
    SERVICE_TASK_SOURCE,
    crmRowPassesTopFilters,
    dispatchServiceTaskListRowDetail,
    findCrmTicketRowInTable,
    getCrmCommunicationTicketIdFromEvent,
    getServiceTaskListRowKey,
    getServiceTaskIdFromEvent,
    getServiceTaskTypeFilterOptions,
    isCrmTicketRow,
    mapRowForStatusIndicator,
    normalizeCrmRowForServiceList,
    normalizeServiceTaskRow,
    statusIndicatorOptionsForRow,
    updateCrmTicketRowIsUnread,
} from '../../utils/serviceTaskCrmMergedList';
import { crmCommunicationTypeLabelKey, renderCrmCommunicationTypeIcon } from '../../utils/crmCommunicationTypeIcons';
import { CrmTicketListDeadlineCell, CrmTicketListStatusCell } from '../../components/crm/communication/CrmTicketListCells';
import { crmSetupStateDisplayHex } from '../../utils/crmStateI18n';
import { resolveWorkflowNextStepListLabel } from '../../utils/workflowNextStepLabel';
import { uiT } from '../../utils/uiTranslate';
import { applyTabulatorRuntimeI18n, applyTabulatorColumnsOnLocale } from '../../utils/tabulatorRuntimeI18n';
import { toLocalDateString } from '../../utils/previewDateRange';
const SERVICE_TASK_ALL_LIST_COLUMN_I18N_KEYS = Object.freeze({
  workflow_next_step_label: 'ServiceTaskTable.Col.NextStep',
  id: 'ServiceTaskTable.Col.Id',
  type: 'ServiceTaskTable.Col.Type',
  defined_id: 'ServiceTaskTable.Col.TicketNumber',
  theme: 'ServiceTaskTable.Col.Name',
  status_id: 'ServiceTaskTable.Col.Status',
  waiting_for_action_by: 'ServiceTaskTable.Col.Deadline',
  custom_delete: 'ServiceTaskTable.Col.Delete',
  created_at: 'ServiceTaskTable.Col.Created',
  last_activity_at: 'ServiceTaskTable.Col.Updated',
  'machine.name': 'ServiceTaskTable.Col.MachinePartnerName',
});



function getDateRange(timePeriod, date) {
  if (!date) return { from: null, to: null };
  const d = Array.isArray(date) ? date[0] : date;
  if (timePeriod === "Za deň") {
    const s = toLocalDateString(new Date(d));
    return { from: s, to: s };
  }
  if (timePeriod === 'Za mesiac') {
    const x = new Date(d);
    const y = x.getFullYear(), m = String(x.getMonth() + 1).padStart(2, '0');
    const lastDay = new Date(y, x.getMonth() + 1, 0).getDate();
    return { from: `${y}-${m}-01`, to: `${y}-${m}-${String(lastDay).padStart(2, '0')}` };
  }
  if (timePeriod === 'Za rok') {
    const y = new Date(d).getFullYear();
    return { from: `${y}-01-01`, to: `${y}-12-31` };
  }
  if (timePeriod === "Vlastné" && Array.isArray(date) && date.length >= 2) {
    return { from: toLocalDateString(new Date(date[0])), to: toLocalDateString(new Date(date[1])) };
  }
  return { from: null, to: null };
}

const PERIOD_PREVIEWS = ['pribudlo', 'nevyriesene', 'ukoncene'];
const SERVICE_TASK_ALL_PRINT_COLUMNS_ALLOWED = ['id', 'type', 'is_unread', 'defined_id', 'theme', 'machine.name', 'status', 'waiting_for_action_by', 'created_at', 'updated_at'];

export default function ServiceTaskAllList({ preview = null, timePeriod = null, date = null }) {
    const { t, locale } = useContext(LocaleContext);

    const [state,dispatch] = useContext(DatabaseContext);
    const {user} = useContext(AuthContext);
    const {toast,getUserColor,getUserInitials,setDialogText,setVisible,setUserMaskFilter,getDateFormat,formatDate,openFavoriteDialog,setFastView,setStandardMaskFilter}= useContext(UtilContext);
    const timezone = getTimezone(state?.module_settings || []);
    const includeCrmTickets = true;
    const canDeleteServiceTask = !!user?.is_superuser || !!user?.permissions?.includes('delete service_task-complete-list');
    const canDeleteCrmTicket = hasFpCrmDelete(user, { mineOnly: false });
    const canDeleteAnyTicket = canDeleteServiceTask || canDeleteCrmTicket;
    const mergedListFetch = useMemo(
        () => (includeCrmTickets ? createServiceTaskCrmMergedFetch(tabulatorGet) : tabulatorGet),
        [includeCrmTickets],
    );

    const ref = useRef(null);
    const previewRef = useRef(preview);
    const timePeriodRef = useRef(timePeriod);
    const dateRef = useRef(date);
    const inFlightRef = useRef({ sig: null, promise: null });
    const completedCacheRef = useRef(new Map());
    const tableBuiltRef = useRef(false);
    const lastResponseRef = useRef(null);
    const savedHScrollRef = useRef({ left: 0, pending: false });
    const resetToFirstPageRef = useRef(false);
    const maskAppliedRef = useRef(false);
    const pendingTaskUpdateRef = useRef(null);
    const needsRedrawRef = useRef(false);
    const pendingRowIdsRef = useRef(new Set());
    const rafRedrawRef = useRef(null);
    const tableContainerRef = useRef(null);
    const currentFilterRef = useRef({ statusValue: null, contractorValue: null, typeValue: null, state: null, user: null });
    const userInteractedRef = useRef(false);
    const isRestoringRef = useRef(false);
    const listMountedRef = useRef(true);
    const [tableSessionKey, setTableSessionKey] = useState(0);
    const [visibleSearch, setVisibleSearch] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const [searchIconColor, setSearchIconColor] = useState('');
    const submittedSearchValueRef = useRef('');
    const pendingInvalidationRef = useRef(false);
    const mutationOverlayRef = useRef(new Map());
    const restartQueuedRef = useRef(false);
    const ajaxGenerationRef = useRef(0);
    const confirmedQueryRef = useRef({ filters: [], sorters: [] });
    const sessionQueryActiveRef = useRef(false);

    const getTable = useCallback(() => ref.current?.table ?? ref.current, []);
    const applyDefaultListLayout = useCallback(() => {
        const table = getTable();
        if (!table) return;
        try {
            table.clearHeaderFilter?.();
            table.setSort?.([]);
            const defaults = user?.is_superuser
                ? { ...DEFAULT_COLUMNS_VISIBLE_SERVICE_ALL, ...(canDeleteAnyTicket ? { custom_delete: true } : {}) }
                : {
                    contractor_id: false,
                    editor: true,
                    id: true,
                    type: true,
                    is_unread: true,
                    defined_id: true,
                    theme: true,
                    'machine.name': true,
                    status_id: true,
                    waiting_for_action_by: true,
                    created_at: true,
                    updated_at: true,
                    ...(canDeleteAnyTicket ? { custom_delete: true } : {}),
                };
            setColumnsVisible(defaults);
            Object.keys(defaults).forEach((field) => {
                if (field === 'status_indicator' || field === 'contractor_id') return;
                if (defaults[field] === false) table.hideColumn?.(field);
                else table.showColumn?.(field);
            });
            table.hideColumn?.('contractor_id');
            table.redraw?.(true);
        } catch (_) {}
    }, [canDeleteAnyTicket, getTable, user?.is_superuser]);

    const isTableVisible = useCallback(() => {
        const el = tableContainerRef.current;
        if (el && el.offsetParent != null && el.clientHeight > 0) return true;
        const table = getTable();
        const tel = table?.getElement?.() ?? table?.element;
        return !!(tel && tel.offsetParent != null && tel.clientHeight > 0);
    }, [getTable]);

    const snapshotConfirmedQuery = useCallback(() => {
        const table = getTable();
        confirmedQueryRef.current = {
            filters: coerceHeaderFilterList(table?.getHeaderFilters?.()),
            sorters: cleanSorters(table?.getSorters?.() || []),
        };
    }, [getTable]);

    const restartFullProgressiveSession = useCallback(() => {
        if (!listMountedRef.current || restartQueuedRef.current) return;
        snapshotConfirmedQuery();
        sessionQueryActiveRef.current = true;
        ajaxGenerationRef.current += 1;
        pendingInvalidationRef.current = false;
        mutationOverlayRef.current = new Map();
        restartQueuedRef.current = true;
        completedCacheRef.current.clear();
        lastResponseRef.current = null;
        inFlightRef.current = { sig: null, promise: null };
        tableBuiltRef.current = false;
        isRestoringRef.current = true;
        resetToFirstPageRef.current = true;
        const table = getTable();
        if (typeof table?.destroy === 'function') table.destroy();
        ref.current = null;
        setTableSessionKey((key) => key + 1);
    }, [getTable, snapshotConfirmedQuery]);

    const requestFullProgressiveSessionRestart = useCallback(() => {
        if (!listMountedRef.current) return;
        if (!isTableVisible()) {
            pendingInvalidationRef.current = true;
            return;
        }
        captureHScroll();
        restartFullProgressiveSession();
    }, [isTableVisible, restartFullProgressiveSession]);

    const refreshFromStart = useCallback(() => requestFullProgressiveSessionRestart(), [requestFullProgressiveSessionRestart]);

    const scheduleRedraw = useCallback(() => {
        if (rafRedrawRef.current != null) return;
        rafRedrawRef.current = requestAnimationFrame(() => {
            const table = getTable();
            rafRedrawRef.current = null;
            if (!table) return;
            const ids = Array.from(pendingRowIdsRef.current);
            pendingRowIdsRef.current.clear();
            needsRedrawRef.current = false;
            ids.forEach((id) => {
                const row = table.getRow?.(id);
                if (!row) return;
                row.reformat?.();
            });
        });
    }, [getTable]);

    const captureHScroll = () => {
        const table = getTable();
        if (!table) return;
        const holder = table.rowManager?.element;
        if (!holder) return;
        savedHScrollRef.current = { left: holder.scrollLeft, pending: true };
    };

    const restoreHScroll = () => {
        if (!savedHScrollRef.current.pending) return;
        const table = getTable();
        if (!table) return;
        const holder = table.rowManager?.element;
        const header = table.columnManager?.contentsElement;
        if (!holder) return;
        const left = savedHScrollRef.current.left;
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                holder.scrollLeft = left;
                if (header) header.scrollLeft = left;
                savedHScrollRef.current.pending = false;
            });
        });
    };
    useEffect(() => {
        listMountedRef.current = true;
        return () => {
            listMountedRef.current = false;
            if (rafRedrawRef.current != null) {
                cancelAnimationFrame(rafRedrawRef.current);
                rafRedrawRef.current = null;
            }
        };
    }, []);

    useEffect(() => {
        const onInvalidate = () => requestFullProgressiveSessionRestart();
        window.addEventListener(SERVICE_TASK_LIST_INVALIDATED_EVENT, onInvalidate);
        return () => window.removeEventListener(SERVICE_TASK_LIST_INVALIDATED_EVENT, onInvalidate);
    }, [requestFullProgressiveSessionRestart]);

    useEffect(() => {
        previewRef.current = preview;
        timePeriodRef.current = timePeriod;
        dateRef.current = date;
    }, [preview, timePeriod, date]);

    const [statusValue,setStatusValue] = useState("Otvorený");
    const [contractorValue,setContractorValue] = useState("Všetky");
    const [typeValue,setTypeValue] = useState("All");

    useEffect(() => {
        if (preview) {
            if (PERIOD_PREVIEWS.includes(preview)) {
                setStatusValue("Všetky");
                setContractorValue("Všetky");
                setTypeValue("All");
            } else {
                setStatusValue("Otvorený");
                setContractorValue("Všetky");
                setTypeValue("All");
            }
        }
    }, [preview]);

    useEffect(() => {
        currentFilterRef.current = { statusValue, contractorValue, typeValue, state, user };
    }, [statusValue, contractorValue, typeValue, state, user]);

    const topFiltersMountedRef = useRef(false);
    useEffect(() => {
        if (!topFiltersMountedRef.current) {
            topFiltersMountedRef.current = true;
            return;
        }
        if (isRestoringRef.current || !tableBuiltRef.current) return;
        userInteractedRef.current = true;
        captureHScroll();
        resetToFirstPageRef.current = true;
        const table = getTable();
        if (table?.rowManager?.element) {
            table.rowManager.element.scrollTop = 0;
            const header = table.columnManager?.contentsElement;
            if (header) header.scrollLeft = 0;
        }
        refreshFromStart();
    }, [statusValue, contractorValue, typeValue, refreshFromStart]);

    /** Parametre z uloženej masky – prvý request ich použije, aby sa neposlali 3 requesty (status → theme → sorters) */
    const initialMaskParams = useMemo(() => {
        if (preview) return {};
        const effective = getEffectiveMask('ServiceTaskAllList', state);
        if (!effective || effective.type !== 'user' || !effective.userMask) return {};
        const list = [effective.userMask];
        const parsedF = safeParse(list[0].filters, {});
        const rawFilters =
            parsedF && typeof parsedF === 'object' && !Array.isArray(parsedF) ? parsedF : {};
        const out = {};
        if (rawFilters.statusValue && rawFilters.statusValue !== 'Všetky') out.filter_status = rawFilters.statusValue;
        if (rawFilters.contractorValue && rawFilters.contractorValue !== 'Všetky') {
            if (rawFilters.contractorValue === 'Mnou vytvorené') out.filter_contractorValue = t('SupportTicketList.Filter.OpenedByMe');
            else if (rawFilters.contractorValue === 'Spomenutý') out.filter_contractorValue = t('SupportTicketList.Filter.Mentioned');
            else if (rawFilters.contractorValue === 'Vykonávateľ') out.filter_contractorValue = t('SupportTicketList.Filter.Executor');
            else out.filter_contractor_id = rawFilters.contractor_id;
        }
        if (rawFilters.typeValue && rawFilters.typeValue !== 'All') out.filter_type = rawFilters.typeValue;
        if (rawFilters.theme != null && String(rawFilters.theme).trim()) out.filter_theme = String(rawFilters.theme).trim();
        if (rawFilters.defined_id != null && String(rawFilters.defined_id).trim()) out.filter_defined_id = String(rawFilters.defined_id).trim();
        if (rawFilters['machine.name'] != null && String(rawFilters['machine.name']).trim()) out.filter_machine = String(rawFilters['machine.name']).trim();
        if (rawFilters.waiting_for_action_by != null && String(rawFilters.waiting_for_action_by).trim()) out.filter_waiting_for_action_by = String(rawFilters.waiting_for_action_by).trim();
        if (rawFilters.created_at != null && String(rawFilters.created_at).trim()) out.filter_created_at = String(rawFilters.created_at).trim();
        if (rawFilters.updated_at != null && String(rawFilters.updated_at).trim()) out.filter_updated_at = String(rawFilters.updated_at).trim();
        if (rawFilters.is_unread === true || rawFilters.is_unread === 'true') out.filter_is_unread = '1';
        else if (rawFilters.is_unread === false || rawFilters.is_unread === 'false') out.filter_is_unread = '0';
        if (rawFilters.status_indicator != null && String(rawFilters.status_indicator).trim()) out.filter_status_indicator = String(rawFilters.status_indicator).trim();
        const sorters = parseSorters(list[0].sorters);
        if (sorters.length) out.sorters = JSON.stringify(sorters.map((s) => ({ field: s.field || s.column, dir: s.dir })));
        return out;
    }, [preview, state.user_mask_filters]);

    const pageSizePc = useMemo(() => {
        const v = (state.module_settings || []).find(s => s.module === 'global' && s.key === 'page_size_pc')?.value;
        const n = parseInt(v, 10);
        return (Number.isFinite(n) && n > 0) ? n : 50;
    }, [state.module_settings]);

    const buildServiceTaskAllQueryParams = useCallback((paramsFromTabulator = {}, opts = {}) => {
        const { includePagination = true, consumeResetPage = true } = opts;
        const extra = includePagination ? { ...extractSafePaginationParams(paramsFromTabulator) } : {};
        if (consumeResetPage && resetToFirstPageRef.current) {
            if (includePagination) extra.page = 1;
            resetToFirstPageRef.current = false;
        }
        if (includePagination && extra.size == null) extra.size = pageSizePc;
        const p = preview ?? previewRef.current;

        if (p) {
            const tp = timePeriod ?? timePeriodRef.current;
            const dt = date ?? dateRef.current;
            const { from, to } = getDateRange(tp, dt);
            extra.preview = p;
            if (from) extra.preview_time_from = from;
            if (to) extra.preview_time_to = to;
            if (statusValue === 'Všetky') extra.filter_status = 'Všetky';
            return extra;
        }

        if (statusValue === 'Všetky') extra.filter_status = 'Všetky';
        else if (statusValue) extra.filter_status = statusValue;
        if (contractorValue && contractorValue !== 'Všetky') {
            if (contractorValue === 'Mnou vytvorené') extra.filter_contractorValue = t('SupportTicketList.Filter.OpenedByMe');
            else if (contractorValue === 'Spomenutý') extra.filter_contractorValue = t('SupportTicketList.Filter.Mentioned');
            else if (contractorValue === 'Vykonávateľ') extra.filter_contractorValue = t('SupportTicketList.Filter.Executor');
            else extra.filter_contractor_id = contractorValue;
        }
        if (typeValue && typeValue !== 'All') extra.filter_type = typeValue;

        const tableReadyForParams = tableBuiltRef.current;
        const applySavedMask = shouldApplySavedMaskOnUnbuiltTable({
            sessionQueryActive: sessionQueryActiveRef.current,
        });
        if (!applySavedMask) {
            applyServiceTaskSessionSnapshotToExtra(extra, confirmedQueryRef.current, {
                service_states: state.service_states,
                userId: user?.id,
                module_settings: state?.module_settings,
                getDateFormat,
                definedIdMapsToTheme: false,
            });
        } else {
            mergeMaintenanceServiceTaskPagedListFiltersAndSorters(extra, {
                getTable,
                tableBuiltForParams: tableReadyForParams,
                userMaskFilters: state.user_mask_filters,
                maskPage: 'ServiceTaskAllList',
                service_states: state.service_states,
                userId: user?.id,
                module_settings: state?.module_settings,
                getDateFormat,
                definedIdMapsToTheme: false,
            });

            // Masku doplňujeme len pri prvom requeste (tabuľka ešte nie je) – keď je tabuľka pripravená, vždy platí len to čo je v header filtroch
            if (!tableReadyForParams) {
                Object.keys(initialMaskParams).forEach((k) => {
                    if (extra[k] === undefined) extra[k] = initialMaskParams[k];
                });
            }
        }

        // Horné filtre (dropdown) vždy znovu nastaviť pred odoslaním – pri zmene header filtra (napr. Vykonanie/Deadline) sa nesmú stratiť
        if (statusValue === 'Všetky') extra.filter_status = 'Všetky';
        else if (statusValue) extra.filter_status = statusValue;
        if (contractorValue && contractorValue !== 'Všetky') {
            if (contractorValue === 'Mnou vytvorené') extra.filter_contractorValue = t('SupportTicketList.Filter.OpenedByMe');
            else if (contractorValue === 'Spomenutý') extra.filter_contractorValue = t('SupportTicketList.Filter.Mentioned');
            else if (contractorValue === 'Vykonávateľ') extra.filter_contractorValue = t('SupportTicketList.Filter.Executor');
            else extra.filter_contractor_id = contractorValue;
        }
        if (typeValue && typeValue !== 'All') extra.filter_type = typeValue;

        appendServiceTaskToolbarSearch(extra, submittedSearchValueRef);

        return extra;
    }, [getTable, state.service_states, state?.module_settings, user?.id, statusValue, contractorValue, typeValue, preview, timePeriod, date, initialMaskParams, pageSizePc]);

    const buildRequestParams = useCallback((paramsFromTabulator = {}) => {
        return buildServiceTaskAllQueryParams(paramsFromTabulator, { includePagination: true, consumeResetPage: true });
    }, [buildServiceTaskAllQueryParams]);

    const buildRequestParamsRef = useRef(buildRequestParams);
    buildRequestParamsRef.current = buildRequestParams;
    const getBuildRequestParams = useCallback((paramsFromTabulator) => buildRequestParamsRef.current(paramsFromTabulator), []);

    const EditRowFormatter = (props) => {
        const rowData = props.cell.getRow().getData();

        const handleView = async () => {
            dispatchServiceTaskListRowDetail(dispatch, rowData, t);
        };

        return (
            <div className="flex justify-center items-start w-full h-full">
                <button type="button" onClick={handleView}>
                    <EditRowIcon />
                </button>
            </div>
        );
    };

    function StatusIndicatorFormatter(props) {
        const rowData = props.cell.getRow().getData();
        const indicatorOpts = statusIndicatorOptionsForRow(rowData);
        return (
            <div className="flex items-center justify-center w-full h-full">
                <StatusIndicator
                    task={mapRowForStatusIndicator(rowData)}
                    moduleSettings={state.module_settings}
                    t={t}
                    locale={locale}
                    settingsModule={indicatorOpts.settingsModule}
                    deadlineField={indicatorOpts.deadlineField}
                />
            </div>
        );
    }

    function MachineNameFormatter(props) {
        const rowData = props.cell.getRow().getData();
        const machineName = rowData?.machine?.name ?? rowData['machine.name'] ?? '—';
        const crmStateColor = rowData?.semaphore_b_color ? crmSetupStateDisplayHex(rowData.semaphore_b_color) : null;
        const crmStateLabel = rowData?.semaphore_b_label ? String(rowData.semaphore_b_label) : '';
        return (
            <div className="flex items-center min-w-0 gap-2">
                {!isCrmTicketRow(rowData) ? <MachineStateDot task={rowData} t={t} locale={locale} /> : null}
                {isCrmTicketRow(rowData) && crmStateColor ? (
                    <span
                        className="inline-block h-4 w-4 shrink-0 rounded-full border border-gray-300"
                        style={{ backgroundColor: crmStateColor }}
                        title={crmStateLabel}
                        aria-hidden
                    />
                ) : null}
                <span className="truncate" title={machineName}>{machineName}</span>
            </div>
        );
    }

    function TruncateSpan({ text }) {
        const displayText = (text ?? '').toString();
        return <span className="block w-full min-w-0 truncate" title={displayText || undefined}>{displayText}</span>;
    }

    function TicketNumberFormatter(props) {
        return <TruncateSpan text={props.cell.getValue()} />;
    }

    function ThemeFormatter(props) {
        return <TruncateSpan text={props.cell.getValue()} />;
    }

    function TypeFormatter(props) {
        const rowData = props.cell.getRow().getData();
        if (isCrmTicketRow(rowData)) {
            const typeTitle = t(crmCommunicationTypeLabelKey(rowData.type));
            return (
                <div className="flex items-center justify-center w-full h-full" title={typeTitle}>
                    {renderCrmCommunicationTypeIcon(rowData.type, { width: 6, height: 6, title: typeTitle })}
                </div>
            );
        }
        let icon;
        let typeTitle;
        switch (rowData.type) {
            case 'Notification': icon = <InfoIcon width={6} height={6} />; typeTitle = t('ServiceTask.Type.Notification'); break;
            case 'Info': icon = <InfoIcon width={6} height={6} />; typeTitle = t('ServiceTask.Type.Info'); break;
            case 'Error': icon = <ErrorIcon width={6} height={6} />; typeTitle = t('ServiceTask.Type.Error'); break;
            case 'Task': icon = <TaskIcon width={6} height={6} />; typeTitle = t('ServiceTask.Type.Task'); break;
            case 'Permission': icon = <PermissionIcon width={6} height={6} />; typeTitle = t('ServiceTask.Type.Permission'); break;
            case 'Need': icon = <NeedIcon width={6} height={6} />; typeTitle = t('ServiceTask.Type.Need'); break;
            case 'Borrow': icon = <BorrowItemIcon width={6} height={6} />; typeTitle = t('ServiceTask.Type.Borrow'); break;
            case 'Emergency': icon = <EmergencyIcon width={6} height={6} />; typeTitle = t('ServiceTask.Type.Emergency'); break;
            case 'TechChange': icon = <TechChangeIcon width={8} height={8} />; typeTitle = t('ServiceTask.Type.TechChange'); break;
            default: icon = <InfoIcon width={6} height={6} />; typeTitle = t('ServiceTask.Type.Info'); break;
        }
        return <div className="flex items-center justify-center w-full h-full" title={typeTitle}>{icon}</div>;
    }

    function ContractorFormatter(props) {
        const rowData = props.cell.getRow().getData();
        const text = formatDate ? formatDate(rowData.created_at, dateFormatGlob, true) : DateTime.fromISO(rowData.created_at).toFormat(`${dateFormatGlob} HH:mm`);
        return (
            <div className="flex items-center justify-start w-full h-full min-w-0 gap-1">
                {rowData?.contractor ? (
                    <Avatar className="shrink-0" title={rowData?.contractor?.employee?.name || rowData?.contractor?.username} label={getUserInitials(rowData?.contractor?.employee?.name || rowData?.contractor?.username)} shape="circle" style={{ backgroundColor: getUserColor(rowData?.contractor?.username), color: '#ffffff' }} />
                ) : null}
                <div className="min-w-0 flex-1 truncate" title={text || undefined}>{text}</div>
            </div>
        );
    }

    function DeleteFormatter(props) {
        const rowData = props.cell.getRow().getData();
        if (isCrmTicketRow(rowData) && !canDeleteCrmTicket) return null;
        if (!isCrmTicketRow(rowData) && !canDeleteServiceTask) return null;
        return <div className='flex items-center justify-center w-full h-full'>
            <button type="button" className='w-fit flex flex-row px-1 py-1 border rounded-md bg-red-900' 
            onClick={() => {deleteTicket(rowData)}} ><DeleteIcon/></button></div>;
    }

    function DateFormatter(props) {
        const rowData = props.cell.getRow().getData();
        const text = formatDate ? formatDate(rowData.updated_at, dateFormatGlob, true) : DateTime.fromISO(rowData.updated_at).toFormat(`${dateFormatGlob} HH:mm`);
        return (
            <div className="flex items-center justify-start w-full h-full min-w-0 gap-1">
                {rowData?.last_touched_by_user ? (
                    <Avatar className="shrink-0" title={rowData?.last_touched_by_user?.employee?.name || rowData?.last_touched_by_user?.username} label={getUserInitials(rowData?.last_touched_by_user?.employee?.name || rowData?.last_touched_by_user?.username)} shape="circle" style={{ backgroundColor: getUserColor(rowData?.last_touched_by_user?.username), color: '#ffffff' }} />
                ) : null}
                <div className="min-w-0 flex-1 truncate" title={text || undefined}>{text}</div>
            </div>
        );
    }

    function StatusFormatter(props) {
        const rowData = props.cell.getRow().getData();

        if (isCrmTicketRow(rowData)) {
            return (
                <CrmTicketListStatusCell
                    rowData={rowData}
                    crmStates={state.crm_states || []}
                    locale={locale}
                />
            );
        }

        // základný status podľa status_id
        let status = state.service_states.find(s => s.id === rowData.status_id);

        // fallback ak sa nenašiel status
        if (!status) {
            return (
                <div className="w-full overflow-hidden">
                    <span className="inline-flex max-w-full items-center rounded-md px-2 py-1 text-base font-normal bg-gray-400 text-white whitespace-nowrap overflow-hidden text-ellipsis" title={t('ServiceTask.Unknown')}>
                        {t('ServiceTask.Unknown')}
                    </span>
                </div>
            );
        }

        // Pri system_inspection (Čaká na kontrolu) zobrazíme executor_state len ak je execution/non_final;
        // inak zobrazíme hlavný stav (Čaká na kontrolu), nie fallback „Pridelený“.
        if (status.phase === 'system_inspection') {
            const execStateId = rowData.execution?.executor_state;
            if (execStateId) {
                const execState = state.service_states.find(s => Number(s.id) === Number(execStateId));
                if (execState && execState.phase === 'execution' && execState.transition_type === 'non_final') {
                    status = execState;
                }
            }
        }

        const hexColor = status.color ? `#${status.color}` : '#9ca3af';

        return (
            <div className="w-full overflow-hidden">
                <span
                    className="inline-flex max-w-full items-center rounded-md px-2 py-1 text-base font-normal text-white whitespace-nowrap overflow-hidden text-ellipsis"
                    style={{ backgroundColor: hexColor }}
                    title={status.name}
                >
                    {status.name}
                </span>
            </div>
        );
    }

    function NextStepFormatter(props) {
        const rowData = props.cell.getRow().getData();
        const label = resolveWorkflowNextStepListLabel(rowData, t);
        return (
            <div className="min-w-0 truncate" title={label || undefined}>
                {label || '—'}
            </div>
        );
    }

    function AwaitingUserFormatter(props) {
        const rowData = props.cell.getRow().getData();

        if (isCrmTicketRow(rowData)) {
            return (
                <CrmTicketListDeadlineCell
                    rowData={rowData}
                    crmStates={state.crm_states || []}
                    formatDate={formatDate}
                    dateFmt={dateFormatGlob}
                    getUserInitials={getUserInitials}
                    getUserColor={getUserColor}
                    timezone={timezone}
                />
            );
        }

        const STATUS = {
            UZAVRENY: 28,
            NESCHVALENY: 18,
            STORNOVANY: 30,
            // prípadne ďalšie
        };

        const deadline = rowData?.deadline
            ? DateTime.fromISO(rowData.deadline)
            : null;
        const today = DateTime.now().setZone(timezone).startOf("day");
        const isExpired = deadline && deadline < today;
        const isClosedStatus = Object.values(STATUS).includes(rowData?.status_id);

        const users = rowData.awaiting_user || [];
        const maxVisible = 3;

        const visibleUsers = users.slice(0, maxVisible);
        const extraUsers = users.slice(maxVisible);
        const extraCount = extraUsers.length;

        const extraNames = extraUsers
            .map((user) => user?.employee?.name || user?.username)
            .filter(Boolean);

        return (
            <div className="flex items-center justify-start w-full h-full min-w-0 flex-wrap gap-1">
                {!isClosedStatus && users.length > 0 && (
                    <AvatarGroup>
                        {visibleUsers.map((user) => (
                            <Avatar
                                key={user.id}
                                title={user?.employee?.name || user?.username}
                                label={getUserInitials(
                                    user?.employee?.name || user?.username
                                )}
                                shape="circle"
                                style={{
                                    backgroundColor: getUserColor(user?.username),
                                    color: "#ffffff",
                                    marginRight: "5px",
                                }}
                            />
                        ))}

                        {extraCount > 0 && (
                            <Avatar
                                label={`+${extraCount}`}
                                shape="circle"
                                // keď podržíš myš, ukáže mená tých "skrytých"
                                title={extraNames.join("\n")}
                                style={{
                                    backgroundColor: "#6b7280", // neutrálna sivá
                                    color: "#ffffff",
                                    marginRight: "5px",
                                }}
                            />
                        )}
                    </AvatarGroup>
                )}

                {deadline && (
                    <div
                        className={
                            isExpired && !isClosedStatus
                                ? "text-red-500 font-semibold shrink-0"
                                : "shrink-0"
                        }
                    >
                        {deadline.toFormat(dateFormatGlob)}
                    </div>
                )}
            </div>
        );
    }

    // sorter funkcia
    function awaitingUserSorter(a, b, rowA, rowB) {
        const dataA = rowA.getData();
        const dataB = rowB.getData();

        const deadlineA = dataA?.deadline
            ? DateTime.fromISO(dataA.deadline)
            : null;
        const deadlineB = dataB?.deadline
            ? DateTime.fromISO(dataB.deadline)
            : null;

        if (deadlineA && deadlineB) {
            if (deadlineA < deadlineB) return -1;
            if (deadlineA > deadlineB) return 1;
            return 0;
        }

        if (deadlineA && !deadlineB) return -1; // A má dátum, B nie
        if (!deadlineA && deadlineB) return 1;  // B má dátum, A nie

        return 0; // obaja nemajú deadline
    }


    const markAsViewed = async (rowData, value) => {
        const taskId = rowData?.id;
        if (!taskId) return;
        if (isCrmTicketRow(rowData)) {
            const url = value
                ? `/api/crm_communication_tickets/${taskId}/mark-as-not-viewed`
                : `/api/crm_communication_tickets/${taskId}/read`;
            try {
                await postRequest(url, {}, true);
                const table = getTable();
                await updateCrmTicketRowIsUnread(table, taskId, !!value);
                dispatch({ type: 'updateCrmTicketViewed', payload: taskId, value: !!value });
            } catch (_) {}
            return;
        }
        const formData = new FormData();
        formData.append("task_id", taskId);
        formData.append("user_id", user.id);
        const url = !value
            ? `/api/service_tasks/${taskId}/mark-as-viewed`
            : `/api/service_tasks/${taskId}/mark-as-not-viewed`;
        try {
            await postRequest(url, formData, true);
            dispatch({ type: "updateTaskViewed", payload: taskId, value: value });
        } catch (err) {
            // fallback, nech sa UI zosynchronizuje
            //dispatch({ type: "updateTaskViewed", payload: taskId, value: value });
        }
    };

    
  function MailIconTemplate(props) {
    const rowData = props.cell.getRow().getData();
    const isUnread = rowData?.is_unread;
    return (
    <div className="flex items-center justify-center w-full h-full gap-2">
        {isUnread ? (
        <button type="button" title={t('ServiceTask.MarkAsRead')} onClick={() => markAsViewed(rowData, false)} className="hover:opacity-75">
            <UnseenIcon />
        </button>
        ) : (
        <button type="button" title={t('ServiceTask.MarkAsUnread')} onClick={() => markAsViewed(rowData, true)} className="hover:opacity-75">
            <SeenIcon />
        </button>
        )}
    </div>
    );
  }

    const normalizeText = (str) =>
        (str || "").toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

    function normalizeFilter(headerValue, rowValue, rowData, filterParams) {
        if (!headerValue) return true; // prázdny filter = zobraz všetko
        return normalizeText(rowValue).includes(normalizeText(headerValue));
    }

    const parseHeaderMulti = (headerValue) => {
        if (headerValue == null || headerValue === '') return [];
        if (Array.isArray(headerValue)) return headerValue.map((x) => String(x ?? '').trim()).filter(Boolean);
        if (typeof headerValue === 'object' && Array.isArray(headerValue?.value)) {
            return headerValue.value.map((x) => String(x ?? '').trim()).filter(Boolean);
        }
        return String(headerValue).split(/[\s,;|]+/).map((x) => x.trim()).filter(Boolean);
    };

    const dateFormatGlob = getDateFormat?.(state?.module_settings) ?? 'dd.MM.yyyy';
    const dateTimeFormatGlob = `${dateFormatGlob} HH:mm`;
    const serviceMinWidth = (title, filterKind = 'text') => {
        const base = filterKind === 'multiselect' ? 88 : 70;
        const perChar = 8;
        return Math.max(base + String(title || '').length * perChar, filterKind === 'multiselect' ? 120 : 100);
    };
    const getMaskColumnLabel = (item) => {
        if (!item) return '';
        if (item.field === 'is_unread') return t('ServiceTaskTable.Col.ReadState');
        const raw = String(item.title ?? '')
            .replace(/<[^>]*>/g, ' ')
            .replace(/&nbsp;/gi, ' ')
            .replace(/&amp;/gi, '&')
            .replace(/\s+/g, ' ')
            .trim();
        return raw || String(item.field ?? '');
    };

    function dateOrUserFilter(headerValue, rowValue, rowData, filterParams) {
        if (!headerValue) return true;
        const raw = String(headerValue || '').trim();
        const field = filterParams?.name;
        const deadlineField = isCrmTicketRow(rowData) && field === 'waiting_for_action_by'
            ? 'waiting_for_action_deadline_at'
            : (field === 'waiting_for_action_by' ? 'deadline' : field);
        if (raw.startsWith('range:')) {
            const parts = raw.slice('range:'.length).split(':');
            if (parts.length >= 2 && parts[0] && parts[1]) {
                const from = DateTime.fromFormat(parts[0], 'yyyy-MM-dd').startOf('day');
                const to = DateTime.fromFormat(parts[1], 'yyyy-MM-dd').endOf('day');
                if (!from.isValid || !to.isValid) return true;
                const source = rowData?.[deadlineField] ?? rowData?.[field];
                const dt = DateTime.fromISO(source || '');
                return dt.isValid ? dt >= from && dt <= to : false;
            }
        }
        const normalize = (str) =>
            (str || "")
                .toString()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .toLowerCase();
        const search = normalize(headerValue);
        const dateVariants = (dt) => {
            if (!dt || !dt.isValid) return '';
            return [
                dt.toFormat(dateFormatGlob),
                dt.toFormat(dateTimeFormatGlob),
                dt.toFormat('HH:mm'),
                dt.toFormat('yyyy-MM-dd'),
            ].join(' ');
        };
        if (filterParams?.name === 'updated_at' && rowData?.last_touched_by_user) {
            const touchedName = rowData.last_touched_by_user?.employee?.name || rowData.last_touched_by_user?.username;
            if (normalize(touchedName).includes(search)) return true;
        }
        if (filterParams?.name === 'updated_at') {
            const dt = DateTime.fromISO(rowData?.updated_at);
            if (normalize(dateVariants(dt)).includes(search)) return true;
        }
        if (filterParams?.name === 'waiting_for_action_by' && rowData?.deadline) {
            const dt = DateTime.fromISO(rowData.deadline);
            if (normalize(dateVariants(dt)).includes(search)) return true;
        }
        if (filterParams?.name === 'waiting_for_action_by' && rowData?.awaiting_user?.length) {
            for (const u of rowData.awaiting_user) {
                const uname = u?.employee?.name || u?.username;
                if (normalize(uname).includes(search)) return true;
            }
        }
        if (filterParams?.name === 'created_at' && rowData?.contractor) {
            const touchedName = rowData.contractor?.employee?.name || rowData.contractor?.username;
            if (normalize(touchedName).includes(search)) return true;
        }
        if (filterParams?.name === 'created_at') {
            const dt = DateTime.fromISO(rowData?.created_at);
            if (normalize(dateVariants(dt)).includes(search)) return true;
        }
        return false;
    }

    function getEffectiveStatusId(rowData) {
        if (!rowData) return null;
        const status = state.service_states?.find(s => s.id === Number(rowData.status_id));
        if (!status) return null;
        if (status.phase === 'system_inspection') {
            const execStateId = rowData.execution?.executor_state;
            if (execStateId) {
                const execStatus = state.service_states?.find(s => s.id === Number(execStateId));
                if (execStatus && execStatus.phase === 'execution' && execStatus.transition_type === 'non_final') {
                    return execStatus.id;
                }
            }
            return status.id;
        }
        return status.id;
    }

    const DEFAULT_COLUMNS_VISIBLE_SERVICE_ALL = { contractor_id: false, editor: true, status_indicator: true, id: true, type: true, is_unread: true, defined_id: true, theme: true, 'machine.name': true, status_id: true, workflow_next_step_label: true, waiting_for_action_by: true, created_at: true, updated_at: true };
    const [columnsVisible, setColumnsVisible] = useState(() => {
        if (user?.is_superuser) return { ...DEFAULT_COLUMNS_VISIBLE_SERVICE_ALL, ...(canDeleteAnyTicket ? { custom_delete: true } : {}) };
        const base = { contractor_id: false, editor: true, id: true, type: true, is_unread: true, defined_id: true, theme: true, 'machine.name': true, status_id: true, waiting_for_action_by: true, created_at: true, updated_at: true };
        return { ...base, ...(canDeleteAnyTicket ? { custom_delete: true } : {}) };
    });
    const getServiceTaskAllPrintColumnOrder = useCallback(() => {
        const table = getTable();
        const allowedSet = new Set(SERVICE_TASK_ALL_PRINT_COLUMNS_ALLOWED);
        const fallback = () => SERVICE_TASK_ALL_PRINT_COLUMNS_ALLOWED.filter((f) => {
            const uiField = f === 'status' ? 'status_id' : f;
            return columnsVisible?.[uiField] !== false;
        });
        if (!table?.getColumns) return fallback();
        const seen = new Set();
        const out = [];
        try {
            for (const col of table.getColumns()) {
                const field = col.getField?.() ?? col.getDefinition?.()?.field;
                if (!field) continue;
                const mapped = field === 'status_id' ? 'status' : field;
                if (!allowedSet.has(mapped)) continue;
                if (columnsVisible?.[field] === false) continue;
                try {
                    if (col.isVisible?.() === false) continue;
                } catch (_) {}
                if (seen.has(mapped)) continue;
                seen.add(mapped);
                out.push(mapped);
            }
        } catch (_) {
            return fallback();
        }
        return out.length > 0 ? out : fallback();
    }, [getTable, columnsVisible]);
    const remoteHeaderFilter = serviceTaskRemoteHeaderFilterAlwaysTrue;

    const serviceTaskAuditColumns = useMemo(() => {
        const cols = buildAuditTabulatorColumns({
            profile: TABULATOR_AUDIT_PROFILES.contractorLastTouched,
            includeId: false,
            dateFormat: dateFormatGlob,
            dateTimeFormat: dateTimeFormatGlob,
            getUserColor,
            getUserInitials,
            textHeaderFilter: remoteHeaderFilter,
            remotePassthrough: true,
        });
        return cols.map((col) => {
            if (col.field === 'created_at') {
                return { ...col, title: t('ServiceTaskTable.Col.Created'), minWidth: DATE_USER_HEADER_FILTER_COL_MIN_WIDTH, widthGrow: 1.2 };
            }
            if (col.field === 'updated_at') {
                return { ...col, title: t('ServiceTaskTable.Col.Updated'), minWidth: DATE_USER_HEADER_FILTER_COL_MIN_WIDTH, widthGrow: 1.2 };
            }
            return col;
        });
    }, [dateFormatGlob, dateTimeFormatGlob, getUserColor, getUserInitials, t]);

    const typeFilterOptions = useMemo(() => getServiceTaskTypeFilterOptions(t), [t]);

    const nextStepFilterOptions = useMemo(() => ([
        { label: t('Workflow.NextStep.Approval'), value: 'approval' },
        { label: t('Workflow.NextStep.Execution'), value: 'execution' },
        { label: t('Workflow.NextStep.Inspection'), value: 'inspection' },
    ]), [t]);

    const nextStepColumn = useMemo(() => ({
        title: t('ServiceTaskTable.Col.NextStep'),
        field: 'workflow_next_step_label',
        hozAlign: 'left',
        minWidth: serviceMinWidth(t('ServiceTaskTable.Col.NextStep'), 'multiselect'),
        widthGrow: 1,
        sorter: 'string',
        formatter: reactFormatter(<NextStepFormatter />),
        headerFilter: primeMultiSelectHeaderFilter,
        headerFilterParams: {
            placeholder: t('Common.All'),
            valueType: 'string',
            options: nextStepFilterOptions,
        },
        headerFilterFunc: remoteHeaderFilter,
    }), [t, nextStepFilterOptions]);

    const columns = useMemo(() => {
        const machineColTitle = includeCrmTickets
            ? t('ServiceTaskTable.Col.MachinePartnerName')
            : t('ServiceTaskTable.Col.Machine');
        const machineColumn = {
            title: machineColTitle,
            field: 'machine.name',
            hozAlign: 'left',
            minWidth: serviceMinWidth(machineColTitle, includeCrmTickets ? 'textInput' : 'multiselect'),
            widthGrow: 1.5,
            sorter: 'string',
            formatter: reactFormatter(<MachineNameFormatter />),
            ...(includeCrmTickets
                ? {
                    headerFilter: inputOnEnterHeaderFilter,
                    headerFilterLiveFilter: false,
                    headerFilterFunc: remoteHeaderFilter,
                }
                : {
                    headerFilter: primeMultiSelectHeaderFilter,
                    headerFilterParams: {
                        placeholder: t('Common.All'),
                        valueType: 'string',
                        options: (state.machines || []).map((m) => ({ label: m.name, value: m.name })).sort((a, b) => (a.label || '').localeCompare(b.label || '', 'sk')),
                    },
                    headerFilterFunc: remoteHeaderFilter,
                }),
        };

        return user?.is_superuser ? [
        { title: '', field: 'editor',hozAlign:"center",width: 44,headerSort:false,formatter: reactFormatter(<EditRowFormatter/>),resizable:false,frozen:true,movable:false},
        { title: '', field: 'status_indicator',hozAlign:"center",width: 44,headerSort:false,formatter: reactFormatter(<StatusIndicatorFormatter/>),resizable:false,frozen:true,
            headerFilter:"list",
            headerFilterParams:{ values: { "": t('Common.All'), "red": "🔴", "orange": "🟠", "green": "🟢" }, clearable: true },
            headerFilterFunc: remoteHeaderFilter,
        },
        { title: t('ServiceTaskTable.Col.Id'), field: 'id', frozen: true, minWidth: 72, width: 80, hozAlign: 'left', sorter: 'number', headerFilter: inputOnEnterHeaderFilter, headerFilterLiveFilter: false, headerFilterFunc: remoteHeaderFilter },
        { title: t('ServiceTaskTable.Col.Type'), field: 'type', frozen: true, hozAlign: 'center', headerHozAlign: 'center', formatter: reactFormatter(<TypeFormatter/>), minWidth:100, sorter: 'string',
            headerFilter: primeMultiSelectHeaderFilter,
            headerFilterParams: {
                placeholder: t('Common.All'),
                valueType: 'string',
                options: typeFilterOptions,
            },
            headerFilterFunc: remoteHeaderFilter,
        },
        { title: '<span style="font-size:20px;line-height:1;">✉</span>', field: 'is_unread', hozAlign: 'center', headerHozAlign: 'center', minWidth: 92, formatter: reactFormatter(<MailIconTemplate/>),
            headerFilter: primeMultiSelectHeaderFilter,
            headerFilterParams: { placeholder: t('Common.All'), valueType: 'string', options: [{ label: t('Common.Unread'), value: 'true' }, { label: t('Common.Read'), value: 'false' }] },
            headerFilterFunc: remoteHeaderFilter,
        },
        { title: t('ServiceTaskTable.Col.TicketNumber'), field: 'defined_id', hozAlign: 'left', minWidth:serviceMinWidth(t('ServiceTaskTable.Col.TicketNumber')),widthGrow:1,formatter: reactFormatter(<TicketNumberFormatter/>),headerFilter: inputOnEnterHeaderFilter, headerFilterLiveFilter: false, headerFilterFunc: remoteHeaderFilter},
        { title: t('ServiceTaskTable.Col.Name'), field: 'theme', hozAlign: 'left', minWidth: serviceMinWidth(t('ServiceTaskTable.Col.Name')),widthGrow:2,formatter: reactFormatter(<ThemeFormatter/>),headerFilter: inputOnEnterHeaderFilter, headerFilterLiveFilter: false, headerFilterFunc: remoteHeaderFilter},
        machineColumn,
        { title: t('ServiceTaskTable.Col.Status'), field: 'status_id', hozAlign: 'left', headerHozAlign: 'left', minWidth: serviceMinWidth(t('ServiceTaskTable.Col.Status'), 'multiselect'), widthGrow:1.1, sorter: 'string', formatter: reactFormatter(<StatusFormatter/>),
            headerFilter: primeMultiSelectHeaderFilter,
            headerFilterParams: {
                placeholder: t('Common.All'),
                valueType: 'number',
                options: (state.service_states || []).map(s => ({ label: s.name, value: Number(s.id) })).sort((a, b) => a.label.localeCompare(b.label, 'sk')),
            },
            headerFilterFunc: remoteHeaderFilter,
        },
        nextStepColumn,
        { title: t('ServiceTaskTable.Col.Deadline'), field: 'waiting_for_action_by', hozAlign: 'left', minWidth:DATE_USER_HEADER_FILTER_COL_MIN_WIDTH,widthGrow:1.3,formatter: reactFormatter(<AwaitingUserFormatter/>),sorter: 'string',headerFilter: dateUserHeaderFilter,headerFilterLiveFilter: false,headerFilterParams: { dateFormat: dateFormatGlob, dateTimeFormat: dateTimeFormatGlob },headerFilterFunc: remoteHeaderFilter,headerFilterFuncParams:{name:"waiting_for_action_by"},},
        ...serviceTaskAuditColumns,
        ...(canDeleteAnyTicket ? [{ title: t('ServiceTaskTable.Col.Delete'), field: 'custom_delete', hozAlign: 'center', width:110,resizable:false,formatter: reactFormatter(<DeleteFormatter/>) }] : []),
        {field: 'contractor_id',visible: false},
        
      ] : [
      { title: '', field: 'editor',hozAlign:"center",width: 44,headerSort:false,formatter: reactFormatter(<EditRowFormatter/>),resizable:false,frozen:true,movable:false},
      { title: t('ServiceTaskTable.Col.Id'), field: 'id', frozen: true, minWidth: 72, width: 80, hozAlign: 'left', sorter: 'number', headerFilter: inputOnEnterHeaderFilter, headerFilterLiveFilter: false, headerFilterFunc: remoteHeaderFilter },
      { title: t('ServiceTaskTable.Col.Type'), field: 'type', frozen: true, hozAlign: 'center', headerHozAlign: 'center', formatter: reactFormatter(<TypeFormatter/>), minWidth:100, sorter: 'string',
            headerFilter: primeMultiSelectHeaderFilter,
            headerFilterParams: {
                placeholder: t('Common.All'),
                valueType: 'string',
                options: typeFilterOptions,
            },
            headerFilterFunc: remoteHeaderFilter,
      },
      { title: '<span style="font-size:20px;line-height:1;">✉</span>', field: 'is_unread', hozAlign: 'center', headerHozAlign: 'center', minWidth: 92, formatter: reactFormatter(<MailIconTemplate/>),
        headerFilter: primeMultiSelectHeaderFilter,
        headerFilterParams: { placeholder: t('Common.All'), valueType: 'string', options: [{ label: t('Common.Unread'), value: 'true' }, { label: t('Common.Read'), value: 'false' }] },
        headerFilterFunc: remoteHeaderFilter,
      },
        { title: t('ServiceTaskTable.Col.TicketNumber'), field: 'defined_id', hozAlign: 'left', minWidth:serviceMinWidth(t('ServiceTaskTable.Col.TicketNumber')),widthGrow:1,formatter: reactFormatter(<TicketNumberFormatter/>),headerFilter: inputOnEnterHeaderFilter, headerFilterLiveFilter: false, headerFilterFunc: remoteHeaderFilter},
        { title: t('ServiceTaskTable.Col.Name'), field: 'theme', hozAlign: 'left', minWidth: serviceMinWidth(t('ServiceTaskTable.Col.Name')),widthGrow:2,formatter: reactFormatter(<ThemeFormatter/>),headerFilter: inputOnEnterHeaderFilter, headerFilterLiveFilter: false, headerFilterFunc: remoteHeaderFilter},
        machineColumn,
        { title: t('ServiceTaskTable.Col.Status'), field: 'status_id', hozAlign: 'left', headerHozAlign: 'left', minWidth: serviceMinWidth(t('ServiceTaskTable.Col.Status'), 'multiselect'), widthGrow:1.1, sorter: 'string', formatter: reactFormatter(<StatusFormatter/>),
            headerFilter: primeMultiSelectHeaderFilter,
            headerFilterParams: {
                placeholder: t('Common.All'),
                valueType: 'number',
                options: (state.service_states || []).map(s => ({ label: s.name, value: Number(s.id) })).sort((a, b) => a.label.localeCompare(b.label, 'sk')),
            },
            headerFilterFunc: remoteHeaderFilter,
        },
        nextStepColumn,
        { title: t('ServiceTaskTable.Col.Deadline'), field: 'waiting_for_action_by', hozAlign: 'left', minWidth:DATE_USER_HEADER_FILTER_COL_MIN_WIDTH,widthGrow:1.3,formatter: reactFormatter(<AwaitingUserFormatter/>),sorter: 'string',headerFilter: dateUserHeaderFilter,headerFilterLiveFilter: false,headerFilterParams: { dateFormat: dateFormatGlob, dateTimeFormat: dateTimeFormatGlob },headerFilterFunc: remoteHeaderFilter,headerFilterFuncParams:{name:"waiting_for_action_by"},},
        ...serviceTaskAuditColumns,
        ...(canDeleteAnyTicket ? [{ title: t('ServiceTaskTable.Col.Delete'), field: 'custom_delete', hozAlign: 'center', width:110,resizable:false,formatter: reactFormatter(<DeleteFormatter/>) }] : []),
        {field: 'contractor_id',visible: false},
      
    ];
    }, [canDeleteAnyTicket, t, locale, user?.is_superuser, user?.permissions, includeCrmTickets, state.machines, state.service_states, state.module_settings, dateFormatGlob, dateTimeFormatGlob, typeFilterOptions, nextStepColumn, serviceTaskAuditColumns]);
  useEffect(() => {
    const table = typeof getTable === 'function' ? getTable() : null;
    if (!table?.getColumns) return;
    applyTabulatorRuntimeI18n(table, t, {
      columnTitleKeys: SERVICE_TASK_ALL_LIST_COLUMN_I18N_KEYS,
      placeholder: typeof t === 'function' ? t('Common.NoData') : undefined,
      reformatRows: true,
    });
  }, [locale, t, getTable]);

  useEffect(() => {
    applyTabulatorColumnsOnLocale(getTable(), columns);
  }, [columns, getTable]);


    function checkStatus(value) {
        setStatusValue(value);
    }

    function checkContractor(value) {
        setContractorValue(value);
    }

    function checkType(value) {
        setTypeValue(value);
    }


    const reject = () => {
        toast?.current?.show({ severity: 'warn', summary: t('ServiceTask.Rejected'), detail: t('ServiceTask.Toast.RequestCancelled'), life: 3000 });
    }
  

    const acceptTicket = (rowData) => {
        const id = rowData?.id;
        const isCrm = isCrmTicketRow(rowData);
        const url = isCrm ? `/api/crm_communication_tickets/${id}` : `/api/service_tasks/${id}`;
        deleteRequest(url)
        .then((response) => {
            toast?.current?.show({ severity: 'info', summary: t('ServiceTask.Confirmed'), life: 3000, detail: t('ServiceTask.Toast.TicketDeleted') });
            const rowKey = getServiceTaskListRowKey(rowData);
            const row = getTable()?.getRows?.().find((r) => getServiceTaskListRowKey(r.getData?.()) === rowKey);
            if (row) row.delete();
        }).catch((reason) => {
            alert(reason);
            toast?.current?.show({ severity: 'warn', summary: t('ServiceTask.Rejected'), detail: t('ServiceTask.TicketDeleteFailed'), life: 3000 });
        });
    };
  

    function deleteTicket(rowData){
        confirmDialog({
            message: t('ServiceTask.ConfirmDeleteTicket'),
            header: t('ServiceTask.ConfirmDeleteTitle'),
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            acceptLabel: t('Common.No'),
            rejectLabel: t('Common.Yes'),
            accept:reject,
            reject:() => acceptTicket(rowData)
        });
    }

    const [expandedKeys, setExpandedKeys] = useState({});
    const overlayRef = useRef(null);
    const [maskVisible, setMaskVisible] = useState(false);


     function setMask(item,value){
        if(item === 'status_indicator' || item === 'contractor_id') return; // gulicky + technický stĺpec
        const columnVisible = {...columnsVisible};
        columnVisible[item] = value;
        for(const val in columnVisible) {
        if(val === 'status_indicator' || val === 'contractor_id') continue;
        if(columnVisible[val]==false){
            getTable()?.hideColumn?.(`${val}`);
        }
        else{
            getTable()?.showColumn?.(`${val}`);
        }
        }
        setColumnsVisible(columnVisible);
        setTimeout(() => {
            const table = getTable();
            table?.redraw?.(true);
        }, 0);
    }

    function changeMarkings(value){
      const columnVisible = { ...columnsVisible };
      for (const val in columnVisible) {
        if (val !== 'status_indicator' && val !== 'contractor_id' && val !== 'id' && val !== 'editor') {
          columnVisible[val] = value;
          if (value) getTable()?.showColumn?.(val);
          else getTable()?.hideColumn?.(val);
        }
      }
      setColumnsVisible(columnVisible);
    }

    const getMaskFields = useMemo(() => (
        columns
            .map((item) => item?.field)
            .filter((field) => field && field !== 'editor' && field !== 'status_indicator' && field !== 'contractor_id')
    ), [columns]);
    const maskFieldToColumn = useMemo(
        () => columns.reduce((acc, item) => {
            if (item?.field) acc[item.field] = item;
            return acc;
        }, {}),
        [columns],
    );
    const itemRenderer = (item, options) => (
        <a className="flex align-items-center px-3 py-2 cursor-pointer items-center bg-[#333] text-white w-[180px]" onClick={options.onClick}>
            <span className={`${item.icon} text-primary`} />
            <span className={`mx-2 ${item.items && 'font-semibold'}`}>{item.label}</span>
            {item.shortcut && <span className="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">{item.shortcut}</span>}
        </a>
      );
    
    
      const handleClickOutside = (event) => {
        if (overlayRef.current && !overlayRef.current.contains(event.target)) {
            setExpandedKeys({});
        }
      };
    
      useEffect(() => {
          document.addEventListener('click', handleClickOutside, true);
          return () => {
              document.removeEventListener('click', handleClickOutside, true);
          };
      }, []);

    // Detail → list: detail payload is not list_row — invalidate progressive session.
    useEffect(() => {
        const task = state.serviceTaskUpdatedInDetail;
        if (!task?.id) return;
        if (classifyServiceTaskDetailListMutation(task) === SESSION_INVALIDATING) {
            requestFullProgressiveSessionRestart();
        }
        dispatch({ type: 'serviceTaskUpdatedInDetail', payload: null });
    }, [state.serviceTaskUpdatedInDetail, dispatch, requestFullProgressiveSessionRestart]);

    // Označenie prečítané v detaile → aktualizuj riadok v tabuľke (ajax list nemá dáta zo state)
    useEffect(() => {
        const u = state.lastTaskViewedUpdate;
        if (!u) return;
        const table = getTable();
        if (!table?.getRow) return;
        const row = table.getRow(getServiceTaskListRowKey(u.taskId)) || table.getRow(u.taskId);
        if (row) {
            const data = row.getData?.();
            if (data) row.update({ ...data, is_unread: u.value }).catch(() => {});
        } else {
            refreshFromStart();
        }
    }, [state.lastTaskViewedUpdate, getTable]);

    useEffect(() => {
        const update = state.lastCrmTicketViewedUpdate;
        if (!update?.ticketId) return;
        const table = getTable();
        if (!table?.getRow) return;
        void updateCrmTicketRowIsUnread(table, update.ticketId, !!update.value);
    }, [state.lastCrmTicketViewedUpdate, getTable]);

    // Keď sa list tab stane viditeľný a má pending redraw
    useEffect(() => {
        if (state.selectedTab != null && isTableVisible() && needsRedrawRef.current) scheduleRedraw();
    }, [state.selectedTab, isTableVisible, scheduleRedraw]);

    // ResizeObserver: keď sa záložka znova zobrazí (návrat z detailu), prekresli tabuľku – oprava neúplného náhľadu (rovnako ako intr003)
    const lastContainerHeightRef = useRef(0);
    useEffect(() => {
        const el = tableContainerRef.current;
        if (!el) return;
        const ro = new ResizeObserver(() => {
            const h = el.clientHeight;
            if (h > 0) {
                const wasHidden = lastContainerHeightRef.current <= 0;
                lastContainerHeightRef.current = h;
                if (wasHidden) requestAnimationFrame(() => getTable()?.redraw?.(true));
                else if (el.offsetParent != null && needsRedrawRef.current) scheduleRedraw();
            } else {
                lastContainerHeightRef.current = 0;
            }
        });
        ro.observe(el);
        return () => ro.disconnect();
    }, [scheduleRedraw, getTable]);

    // Pusher – jednotný getId; GET /api/service_tasks/{id}/list_row, potom update/add/delete; deferred redraw
    useEffect(() => {
        const channel = getPusherChannel();
        if (!channel) return;

        const DEDUPE_MS = 800;
        const lastHandled = { key: '', at: 0 };
        const shouldSkip = (eventType, id) => {
            if (id == null) return true;
            const key = `${eventType}-${id}`;
            const now = Date.now();
            if (lastHandled.key === key && now - lastHandled.at < DEDUPE_MS) return true;
            lastHandled.key = key;
            lastHandled.at = now;
            return false;
        };

        const captureScroll = () => {
            const table = getTable();
            if (!table?.rowManager?.element) return null;
            const holder = table.rowManager.element;
            const header = table.columnManager?.contentsElement;
            return { v: holder.scrollTop, h: header ? header.scrollLeft : holder.scrollLeft || 0 };
        };
        const restoreScroll = (pos) => {
            if (!pos) return;
            requestAnimationFrame(() => {
                const table = getTable();
                if (!table?.rowManager?.element) return;
                const holder = table.rowManager.element;
                const header = table.columnManager?.contentsElement;
                holder.scrollTop = pos.v;
                if (header) header.scrollLeft = pos.h;
            });
        };

        const applyListRow = (normalizedRow) => {
            const table = getTable();
            if (!normalizedRow || !table?.getRow) return;
            const rowKey = getServiceTaskListRowKey(normalizedRow);
            const rc = table.getRow?.(rowKey);
            if (rc) {
                rc.update(normalizedRow).catch(() => {});
                pendingRowIdsRef.current.add(rowKey);
                if (isTableVisible()) scheduleRedraw();
                else needsRedrawRef.current = true;
                return;
            }
            requestFullProgressiveSessionRestart();
        };

        const invalidateFromRemote = () => requestFullProgressiveSessionRestart();

        const onUpdated = (data) => {
            const id = getServiceTaskIdFromEvent(data);
            if (id == null || shouldSkip('updated', id)) return;
            const table = getTable();
            if (!table?.getRow) return;
            const scroll = captureScroll();
            getRequest(`/api/service_tasks/${id}/list_row`)
                .then((res) => {
                    const row = normalizeServiceTaskRow(res?.data ?? res);
                    if (!row) return;
                    applyListRow(row);
                    restoreScroll(scroll);
                })
                .catch(() => {});
        };

        const onCreated = (data) => {
            const id = getServiceTaskIdFromEvent(data);
            if (id == null || shouldSkip('created', id)) return;
            invalidateFromRemote();
        };

        const onDeleted = (data) => {
            const id = getServiceTaskIdFromEvent(data);
            if (id == null || shouldSkip('deleted', id)) return;
            const table = getTable();
            const rowKey = getServiceTaskListRowKey(id, SERVICE_TASK_SOURCE);
            const row = table?.getRow?.(rowKey) ?? table?.getRows?.().find((r) => r.getData?.()?.id === id && !isCrmTicketRow(r.getData?.()));
            if (row) row.delete();
        };

        const onCrmUpdated = (data) => {
            if (!includeCrmTickets) return;
            const id = getCrmCommunicationTicketIdFromEvent(data);
            if (id == null || shouldSkip('crm-updated', id)) return;
            const table = getTable();
            if (!table?.getRow) return;
            const scroll = captureScroll();
            getRequest(`/api/crm_communication_tickets/${id}/list_row?portal_view=1`)
                .then((res) => {
                    const row = normalizeCrmRowForServiceList(res?.data ?? res);
                    if (!row) return;
                    applyListRow(row);
                    restoreScroll(scroll);
                })
                .catch(() => invalidateFromRemote());
        };

        const onCrmCreated = (data) => {
            if (!includeCrmTickets) return;
            const id = getCrmCommunicationTicketIdFromEvent(data);
            if (id == null || shouldSkip('crm-created', id)) return;
            invalidateFromRemote();
        };

        const onCrmDeleted = (data) => {
            if (!includeCrmTickets) return;
            const id = getCrmCommunicationTicketIdFromEvent(data);
            if (id == null || shouldSkip('crm-deleted', id)) return;
            const table = getTable();
            const row = findCrmTicketRowInTable(table, id);
            if (row) row.delete();
        };

        channel.bind('service_task.updated', onUpdated);
        channel.bind('service_task.created', onCreated);
        channel.bind('service_task.deleted', onDeleted);
        if (includeCrmTickets) {
            channel.bind('crm_communication_ticket.updated', onCrmUpdated);
            channel.bind('crm_communication_ticket.created', onCrmCreated);
            channel.bind('crm_communication_ticket.deleted', onCrmDeleted);
        }
        return () => {
            channel.unbind('service_task.updated', onUpdated);
            channel.unbind('service_task.created', onCreated);
            channel.unbind('service_task.deleted', onDeleted);
            if (includeCrmTickets) {
                channel.unbind('crm_communication_ticket.updated', onCrmUpdated);
                channel.unbind('crm_communication_ticket.created', onCrmCreated);
                channel.unbind('crm_communication_ticket.deleted', onCrmDeleted);
            }
        };
    }, [getTable, isTableVisible, scheduleRedraw, includeCrmTickets, requestFullProgressiveSessionRestart]);

    const hasApplicableStandardMask = useMemo(() => {
        const row = (state.standard_mask_filters || []).find((m) => m.page === 'ServiceTaskAllList');
        if (!row) return false;
        try {
            const attributes = sanitizeTabulatorLayoutAttributes(typeof row.attributes === 'string' ? JSON.parse(row.attributes) : row.attributes);
            return Array.isArray(attributes) && attributes.length > 1;
        } catch (_) {
            return false;
        }
    }, [state.standard_mask_filters]);

    const confirmApplyStandardLayoutToUserMask = () => {
        const standard = (state.standard_mask_filters || []).find((m) => m.page === 'ServiceTaskAllList');
        if (!standard) {
            toast?.current?.show({ severity: 'warn', summary: t('ServiceTask.StandardMask'), detail: t('ServiceTask.NoStandardMaskSaved'), life: 4000 });
            return;
        }
        let attributes = [];
        let cols = {};
        try {
            attributes = sanitizeTabulatorLayoutAttributes(typeof standard.attributes === 'string' ? JSON.parse(standard.attributes) : (standard.attributes || []));
            cols = typeof standard.columns === 'string' ? JSON.parse(standard.columns) : (standard.columns || {});
        } catch (_) {
            toast?.current?.show({ severity: 'warn', summary: t('ServiceTask.StandardMask'), detail: t('ServiceTask.StandardMaskInvalidData'), life: 4000 });
            return;
        }
        if (!Array.isArray(attributes) || attributes.length <= 1) {
            toast?.current?.show({ severity: 'warn', summary: t('ServiceTask.StandardMask'), detail: t('ServiceTask.StandardMaskInvalidLayout'), life: 4000 });
            return;
        }
        const colsForSave = { ...(cols || {}), status_indicator: true };
        confirmDialog({
            message: t('ServiceTask.ApplyStandardMaskPrompt'),
            header: t('ServiceTask.StandardMask'),
            icon: 'pi pi-info-circle',
            acceptLabel: t('Common.Use'),
            rejectLabel: t('Common.Cancel'),
            accept: () => {
                setUserMaskFilter('ServiceTaskAllList', 'all', colsForSave, null, attributes, null, () => {
                    const table = getTable();
                    if (!table) return;
                    isRestoringRef.current = true;
                    try { table.setColumnLayout?.(attributes); } catch (_) {}
                    setColumnsVisible(colsForSave);
                    Object.keys(colsForSave).forEach((field) => {
                        if (field === 'status_indicator' || field === 'contractor_id') return;
                        if (colsForSave[field] === false) table.hideColumn?.(field);
                        else table.showColumn?.(field);
                    });
                    table.hideColumn?.('contractor_id');
                    setTimeout(() => {
                        isRestoringRef.current = false;
                        table.redraw?.(true);
                        captureHScroll();
                        refreshFromStart();
                    }, 0);
                });
            },
        });
    };

    const items = [
        {
          key: '0',
                label: t('Common.Actions'),
          icon: 'pi pi-sliders-v',
          template: itemRenderer,
          items: [
                {
                  key: '0_1',
                  label: t('Common.SetFilter'),
                  icon: 'pi pi-filter',
                  command: () => {setServiceSelects();},
                  template: itemRenderer,
                },
                {
                  key: '0_2',
                  label: t('Common.ClearFilter'),
                  icon: 'pi pi-filter-slash',
                  command: () => {clearServiceSelects();},
                  template: itemRenderer,
                },
                {
                    key: '0_3',
                    label: t('Common.SetSorting'),
                    icon: 'pi pi-sort-alt',
                    command: () => {
                        const rawSorters = getTable()?.getSorters?.() || [];
                        const pureSorters = rawSorters
                          .map(s => {
                              const field = s.field || s.column?.getField?.();
                              if (!field) return null;
                              const dir = s.dir === 'desc' ? 'desc' : 'asc';
                              return { field, dir };
                          })
                          .filter(Boolean);
                        setUserMaskFilter("ServiceTaskAllList","set_sorters",null,null,null,pureSorters);
                        setExpandedKeys({});
                    },
                    template: itemRenderer,
                },
                {
                    key: '0_4',
                    label: t('Common.ClearSorting'),
                    icon: 'pi pi-sort-alt-slash',
                    command: () => {setUserMaskFilter("ServiceTaskAllList","set_sorters",null,null,null,[]);getTable()?.setSort?.([]);setExpandedKeys({});},
                    template: itemRenderer,
                },
                {
                  key: '0_5',
                  label: t('Common.SetMask'),
                  icon: 'pi pi-server',
                  command: () => {setMaskVisible(true);setExpandedKeys({});},
                  template: itemRenderer,
                },
                ...(hasApplicableStandardMask ? [{
                  key: '0_5s',
                  label: t('Common.StandardMask'),
                  icon: 'pi pi-clone',
                  command: () => { confirmApplyStandardLayoutToUserMask(); setExpandedKeys({}); },
                  template: itemRenderer,
                }] : []),
          ]
        }
    ];

    function setServiceSelects(){
        const headerFilters = getTable()?.getHeaderFilters?.() || [];

        // premapovať header filtre do objektu {field: value}, ale vynechať status_id
        const headerFilterObj = headerFilters.reduce((acc, f) => {
            if (!f?.field || f.field === "status_id") return acc;
            acc[f.field] = f.value;
            return acc;
        }, {});

        // pridať manuálne select filtre
        const filters = {
            ...headerFilterObj,
            statusValue,
            contractorValue,
            typeValue,
        };

        // uložiť do DB – filters je vždy objekt (nie pole)
        setUserMaskFilter("ServiceTaskAllList", "set_filters", null, filters, null);
        setExpandedKeys({});
    }

    function clearServiceSelects() {
        // reset select filtrov
        checkStatus("Otvorený");
        checkContractor("Všetky");
        checkType("All");

        // reset Tabulator header filtrrov
        const table = getTable();
        if (table) table.clearHeaderFilter?.(); // vymaže všetky header filtre

        // vymazať uložené filtre z DB – ulož prázdny objekt, nie pole
        setUserMaskFilter("ServiceTaskAllList", "set_filters", null, {}, null);

        // zresetovať expanded keys
        setExpandedKeys({});
    }

    const [printChoiceVisible, setPrintChoiceVisible] = useState(false);
    const [printOrientationChoice, setPrintOrientationChoice] = useState('landscape');
    const [printLayoutChoice, setPrintLayoutChoice] = useState('branded');

    const buildServiceTaskAllExportQueryString = useCallback((opts = {}) => {
        const exportParams = buildServiceTaskAllQueryParams({}, { includePagination: false, consumeResetPage: false });
        if (includeCrmTickets) exportParams.include_crm = 1;
        return buildExportQueryStringFromParams(exportParams, opts);
    }, [buildServiceTaskAllQueryParams, includeCrmTickets]);

    const runServiceTaskAllPrint = async () => {
        try {
            setPrintChoiceVisible(false);
            setDialogText(t('Common.PreparingPrint'));
            setVisible(true);
            const suffix = buildServiceTaskAllExportQueryString({
                includePrintColumns: true,
                printLayout: printLayoutChoice,
                printOrientation: printOrientationChoice,
                printColumns: getServiceTaskAllPrintColumnOrder(),
            });
            const html = await fetchTextGet(`/api/service_all_tasks/export/print${suffix}`);
            const opened = openPrintHtmlWindow(html);
            if (!opened) {
                toast?.current?.show({ severity: 'warn', summary: t('Common.Print'), life: 4000, detail: t('Common.EnablePopups') });
                return;
            }
        } catch (e) {
            toast?.current?.show({ severity: 'error', summary: t('Common.Print'), life: 5000, detail: e?.message || t('ServiceTask.PrintFailed') });
        } finally {
            setVisible(false);
        }
    };

    const exportServiceTaskAllXlsx = async () => {
        const exportDocTitle = t(EXPORT_DOCUMENT_TITLE_KEYS.SERVICE_TASK_FULL_LIST);
        try {
            setDialogText(t('Common.PreparingExport'));
            setVisible(true);
            const suffix = buildServiceTaskAllExportQueryString();
            const defaultXlsx = xlsxDownloadFilename(exportDocTitle);
            const { blob, filename } = await downloadBlobGet(`/api/service_all_tasks/export/xlsx${suffix}`, defaultXlsx);
            triggerBlobDownload(blob, filename || defaultXlsx);
            toast?.current?.show({ severity: 'info', summary: t('Common.Done'), life: 3000, detail: t('ServiceTask.ExportDownloaded') });
        } catch (e) {
            toast?.current?.show({ severity: 'error', summary: t('Common.Export'), life: 5000, detail: e?.message || t('ServiceTask.ExportFailed') });
        } finally {
            setVisible(false);
        }
    };

    const searchTable = () => {
        const normalized = String(searchValue ?? '').trim();
        submittedSearchValueRef.current = normalized;
        setSearchIconColor(normalized === '' ? '' : 'active');
        captureHScroll();
        requestFullProgressiveSessionRestart();
        setVisibleSearch(false);
    };

    const scrollToFirst = () => scrollToFirstUtil(getTable());
    const scrollUp = () => scrollUpUtil(getTable());
    const scrollDown = () => scrollDownUtil(getTable());
    const scrollToLast = () => scrollToLastUtil(getTable());
    const canSetStandardMask = user?.permissions?.includes('set standard mask');

    const confirmSaveStandardMask = () => {
        confirmDialog({
            message: t('ServiceTask.SaveStandardMaskPrompt'),
            header: t('ServiceTask.SaveStandardMaskTitle'),
            icon: 'pi pi-info-circle',
            acceptLabel: t('Common.Save'),
            rejectLabel: t('Common.Cancel'),
            accept: () => {
                const table = getTable();
                const layout = getTabulatorLayoutForStandardMask(table);
                if (!layout) {
                    toast?.current?.show({ severity: 'warn', summary: t('ServiceTask.Mask'), detail: t('ServiceTask.TableNotReady'), life: 3500 });
                    return;
                }
                const cols = { ...columnsVisible, status_indicator: true };
                if (!Object.values(cols).some(Boolean)) {
                    toast?.current?.show({ severity: 'warn', summary: t('ServiceTask.StandardMask'), detail: t('ServiceTask.AtLeastOneColumnVisible'), life: 3500 });
                    return;
                }
                setStandardMaskFilter('ServiceTaskAllList', cols, layout.attributes);
            },
        });
    };

    return (
        <>
            <div className='relative flex flex-col bg-gray-100 w-full h-[calc(100vh_-_137px)] py-4 px-4 overflow-y-auto'>
                    
                    <div className="w-full px-4 py-4 bg-[#333] text-white border rounded-sm">
                        <h2 className="text-left text-xl font-semibold whitespace-nowrap">{t('ServiceTaskAllList.Title')}</h2>
                    </div>
                    <div className="flex flex-row flex-wrap items-start bg-white shadow-md p-4 gap-4">
                    
                    <div className="flex flex-row flex-wrap items-center gap-2">

                    {/* Status */}
                    <label className="font-semibold">{t('ServiceTaskTable.Col.Status')}:</label>
                    <select
                        className="bg-[#333] text-white px-4 h-11 rounded-md"
                        value={statusValue} onChange={(e) => checkStatus(e.target.value)}
                    >
                        <option value="Otvorený">{t('ServiceTask.Status.Open')}</option>
                        <option value="Uzavretý">{t('ServiceTask.Status.Closed')}</option>
                        <option value="Neschválený">{t('ServiceTask.Status.Rejected')}</option>
                        <option value="Stornovaný">{t('ServiceTask.Status.Cancelled')}</option>
                        <option value="Všetky">{t('Common.All')}</option>
                    </select>

                    {/* Tikety používateľa */}
                    <select
                        className="bg-[#333] text-white px-4 h-11 rounded-md"
                        value={contractorValue} onChange={(e) => checkContractor(e.target.value)}
                    >
                        <option value="Všetky">{t('ServiceTask.Filter.AllTickets')}</option>
                        <option value="Mnou vytvorené">{t('ServiceTask.Filter.CreatedByMe')}</option>
                        <option value="Spomenutý">{t('ServiceTask.Filter.Mentioned')}</option>
                        <option value="Vykonávateľ">{t('ServiceTask.Filter.Executor')}</option>
                    </select>

                    {/* Typ tiketu */}
                    <label className="font-semibold">{t('ServiceTask.Filter.TicketType')}:</label>
                    <select
                        className="bg-[#333] text-white px-4 h-11 rounded-md"
                        value={typeValue} onChange={(e) => checkType(e.target.value)}
                    >
                        <option value="All">{t('Common.All')}</option>
                        <option value="Info">{t('ServiceTask.Type.Info')}</option>
                        <option value="Error">{t('ServiceTask.Type.Error')}</option>
                        <option value="Task">{t('ServiceTask.Type.Task')}</option>
                        <option value="TechChange">{t('ServiceTask.Type.TechChange')}</option>
                        <option value="Permission">{t('ServiceTask.Type.Permission')}</option>
                        <option value="Need">{t('ServiceTask.Type.Need')}</option>
                        <option value="Borrow">{t('ServiceTask.Type.Borrow')}</option>
                        <option value="Emergency">{t('ServiceTask.Type.Emergency')}</option>
                        {includeCrmTickets && CRM_TOP_TYPE_DROPDOWN_OPTIONS.map((opt) => (
                            <option key={opt.value} value={opt.value}>{t(opt.labelKey)}</option>
                        ))}
                    </select>
                    </div>

                    <div className="bg-[#333] text-white rounded-md h-11 px-2 inline-flex items-center gap-1">
                        <button type="button" className="h-9 w-9 inline-flex items-center justify-center rounded hover:bg-[#444] focus:outline-none" onClick={() => setPrintChoiceVisible(true)} title={t('Common.Print')}><PrintIcon className="shrink-0" /></button>
                        <button type="button" className="h-9 w-9 inline-flex items-center justify-center rounded hover:bg-[#444] focus:outline-none" onClick={exportServiceTaskAllXlsx} title={t('Common.ExportToExcel')}><ExportIcon className="shrink-0" /></button>
                        <button type="button" className="h-9 w-9 inline-flex items-center justify-center rounded hover:bg-[#444] focus:outline-none" onClick={() => (searchIconColor !== 'active' ? setVisibleSearch(true) : (() => { setSearchIconColor(''); setSearchValue(''); submittedSearchValueRef.current = ''; captureHScroll(); requestFullProgressiveSessionRestart(); })())} title={searchIconColor !== 'active' ? t('Common.Search') : t('Common.CancelSearch')}>{searchIconColor === '' ? <MdSearch fill="#fff" strokeWidth="0" className="w-[28px] h-[28px]" aria-hidden="true" /> : <MdSearchOff fill="#fff" strokeWidth="0" className="w-[28px] h-[28px]" aria-hidden="true" />}</button>
                        <button type="button" className="h-9 w-9 inline-flex items-center justify-center rounded hover:bg-[#444] focus:outline-none" onClick={() => { userInteractedRef.current = true; captureHScroll(); requestFullProgressiveSessionRestart(); }} title={t('Common.Refresh')}><RefreshIcon className="shrink-0" /></button>
                        <div className="h-9 inline-flex items-center text-white/70"><VerticalLineIcon /></div>
                        <button type="button" className="h-9 w-9 inline-flex items-center justify-center rounded hover:bg-[#444] focus:outline-none" onClick={scrollToFirst} title={t('Icon.First')}><BackToFirstIcon /></button>
                        <button type="button" className="h-9 w-9 inline-flex items-center justify-center rounded hover:bg-[#444] focus:outline-none" onClick={scrollUp} title={t('Icon.Previous')}><BackIcon /></button>
                        <button type="button" className="h-9 w-9 inline-flex items-center justify-center rounded hover:bg-[#444] focus:outline-none" onClick={scrollDown} title={t('Icon.Next')}><ForwardIcon /></button>
                        <button type="button" className="h-9 w-9 inline-flex items-center justify-center rounded hover:bg-[#444] focus:outline-none" onClick={scrollToLast} title={t('Icon.Last')}><ForwardToLastIcon /></button>
                        <div className="h-9 inline-flex items-center text-white/70"><VerticalLineIcon /></div>
                        <button type="button" className="h-9 w-9 inline-flex items-center justify-center rounded hover:bg-[#444] focus:outline-none" onClick={() => openFavoriteDialog(t("ServiceTaskAllList.Title"), "ServiceTaskAllList")} title={t('ServiceTaskTable.Toolbar.AddFavorite')}><FavoriteIcon /></button>
                        <button type="button" className="h-9 w-9 inline-flex items-center justify-center rounded hover:bg-[#444] focus:outline-none" onClick={() => setFastView("ServiceTaskAllList", columnsVisible, columns)} title={t('ServiceTaskTable.Toolbar.QuickView')}><PriceIcon /></button>
                        {canSetStandardMask ? (
                            <button type="button" className="h-9 w-9 inline-flex items-center justify-center rounded hover:bg-[#444] focus:outline-none" onClick={confirmSaveStandardMask} title={t('ServiceTask.SaveStandardMaskTooltip')}>
                                <i className="pi pi-bookmark text-white" aria-hidden="true" />
                            </button>
                        ) : null}
                    </div>

                    <div className="relative w-full md:w-auto">
                        <div className="absolute z-50 top-0 left-0 bg-[#333] rounded-md shadow-lg overflow-hidden" ref={overlayRef}>
                            <PanelMenu
                            model={items}
                            expandedKeys={expandedKeys}
                            onExpandedKeysChange={setExpandedKeys}
                            className="w-full bg-[#333] text-white"
                            />
                        </div>
                    </div>
                </div>
                <div ref={tableContainerRef}>
                    <ReactTabulator
                    key={tableSessionKey}
                    className='h-[calc(100vh_-_313px)]'
                    onRef={(r) => (ref.current = r?.current ?? r)}
                    columns={columns}
                    events={{
                        headerFilterChanged: () => {
                            if (isRestoringRef.current) return;
                            userInteractedRef.current = true;
                            requestFullProgressiveSessionRestart();
                        },
                        sortChanged: () => {
                            if (!isRestoringRef.current) {
                                userInteractedRef.current = true;
                                requestFullProgressiveSessionRestart();
                            }
                        },
                        dataSorted: () => {
                            if (!isRestoringRef.current) userInteractedRef.current = true;
                        },
                        tableBuilt: () => {
                            tableBuiltRef.current = true;
                            restartQueuedRef.current = false;
                            setTimeout(() => {
                                isRestoringRef.current = false;
                                sessionQueryActiveRef.current = false;
                            }, 0);
                            if (preview) {
                                tableBuiltRef.current = true;
                                const isPeriod = PERIOD_PREVIEWS.includes(preview);
                                checkStatus(isPeriod ? "Všetky" : "Otvorený");
                                checkContractor("Všetky");
                                checkType("All");
                                setStatusValue(isPeriod ? "Všetky" : "Otvorený");
                                setContractorValue("Všetky");
                                setTypeValue("All");
                                setTimeout(() => getTable()?.clearHeaderFilter?.(), 0);
                                return;
                            }
                            isRestoringRef.current = true;
                            userInteractedRef.current = false;
                            const initialRestore = !maskAppliedRef.current;
                            const effective = getEffectiveMask('ServiceTaskAllList', state);
                            const mask = effective?.type === 'user' && effective.userMask ? [effective.userMask] : [];
                            const parsedFilters = mask.length > 0 ? safeParse(mask[0].filters, {}) : null;
                            const rawFilters =
                                parsedFilters && typeof parsedFilters === 'object' && !Array.isArray(parsedFilters)
                                    ? parsedFilters
                                    : null;
                            const plan = resolveServiceTaskListTableBuiltRestore({
                                initialRestore,
                                currentTopFilters: { statusValue, contractorValue, typeValue },
                                maskFilters: rawFilters,
                                maskSorters: mask.length > 0 ? safeParse(mask[0].sorters, []) : [],
                                sessionHeaderFilters: confirmedQueryRef.current?.filters || [],
                                sessionSorters: confirmedQueryRef.current?.sorters || [],
                            });
                            const table = getTable();
                            table?.blockRedraw?.();
                            try {
                                if (initialRestore && mask.length > 0) {
                                    const attributes = sanitizeTabulatorLayoutAttributes(safeParse(mask[0].attributes, []));
                                    if (Array.isArray(attributes) && attributes.length > 1) {
                                        table?.setColumnLayout?.(attributes);
                                    }
                                    const json_columns = safeParse(mask[0].columns, {});
                                    if (json_columns && typeof json_columns === 'object' && !Array.isArray(json_columns)) {
                                        setColumnsVisible(json_columns);
                                        setTimeout(() => table?.redraw?.(true), 0);
                                        for (const column in json_columns) {
                                            if (column === 'status_indicator' || column === 'contractor_id') continue;
                                            if (json_columns[column] === false) table?.hideColumn?.(column);
                                            else table?.showColumn?.(column);
                                        }
                                    }
                                    table?.hideColumn?.('contractor_id');
                                } else if (initialRestore && effective?.type === 'standard' && effective.standardMask) {
                                    const standard = effective.standardMask;
                                    let attributes = [];
                                    let json_columns = {};
                                    try {
                                        attributes = sanitizeTabulatorLayoutAttributes(typeof standard.attributes === 'string' ? JSON.parse(standard.attributes) : (standard.attributes || []));
                                    } catch (_) {
                                        attributes = [];
                                    }
                                    try {
                                        json_columns = typeof standard.columns === 'string' ? JSON.parse(standard.columns) : (standard.columns || {});
                                    } catch (_) {
                                        json_columns = {};
                                    }
                                    if (Array.isArray(attributes) && attributes.length > 1) {
                                        table?.setColumnLayout?.(attributes);
                                    }
                                    if (json_columns && typeof json_columns === 'object') {
                                        const colsWithIndicator = { ...json_columns, status_indicator: true };
                                        setColumnsVisible(colsWithIndicator);
                                        Object.keys(colsWithIndicator).forEach((column) => {
                                            if (column === 'status_indicator' || column === 'contractor_id') return;
                                            if (colsWithIndicator[column] === false) table?.hideColumn?.(column);
                                            else table?.showColumn?.(column);
                                        });
                                        table?.hideColumn?.('contractor_id');
                                    }
                                } else if (initialRestore) {
                                    applyDefaultListLayout();
                                }

                                checkStatus(plan.statusValue);
                                checkContractor(plan.contractorValue);
                                checkType(plan.typeValue);
                                (plan.headerFilters || []).forEach((filter) => {
                                    table?.setHeaderFilterValue?.(filter.field, filter.value, true);
                                });
                                if (plan.sorters.length > 0) table?.setSort?.(plan.sorters);
                                if (initialRestore) maskAppliedRef.current = true;
                            } finally {
                                table?.restoreRedraw?.(true);
                            }
                            tableBuiltRef.current = true;
                            setTimeout(() => { isRestoringRef.current = false; }, 0);
                        },
                        renderComplete: () => {
                            restoreHScroll();
                        },
                        columnMoved:() => {
                            if (!userInteractedRef.current || isRestoringRef.current) return;
                            setUserMaskFilter("ServiceTaskAllList","column_move",null,null,getTable()?.getColumnLayout?.());
                        },
                        columnResized: () => {
                            if (!userInteractedRef.current || isRestoringRef.current) return;
                            setUserMaskFilter("ServiceTaskAllList", "column_resized", null, null, getTable()?.getColumnLayout?.());
                        },
                        dataChanged: () => {
                            // pri obnovovaní masky neprepisuj filtre defaultami
                            if (isRestoringRef.current) return;
                            checkStatus(statusValue);
                            checkContractor(contractorValue);
                            checkType(typeValue);
                        },
                    }}
                    options={{
                        index: includeCrmTickets ? "list_row_id" : "id",
                        layout: "fitColumns",
                        renderHorizontal: "virtual",
                        rowHeight: TABULATOR_AUDIT_MIN_ROW_HEIGHT,
                        rowClick: (e, row) => {
                            if (e?.target?.closest?.('button, a, input, select, textarea, [role="button"]')) return;
                            const rowData = row?.getData?.();
                            if (!rowData) return;
                            dispatchServiceTaskListRowDetail(dispatch, rowData, t);
                        },
                        dataLoader: true,
                        dataLoaderLoading: t('ServiceTask.TableLoadingData'),
                        dataLoaderError: t('ServiceTask.TableLoadFailed'),
                        placeholder: t('ServiceTask.TableNoData'),
                        height: "calc(100vh - 313px)",
                        progressiveLoad: "scroll",
                        progressiveLoadScrollMargin: 80,
                        progressiveLoadDelay: 200,
                        paginationSize: pageSizePc,
                        pagination: false,
                        filterMode: "remote",
                        sortMode: "remote",
                        ajaxURL: "/api/service_all_tasks/paged",
                        ajaxParams: () => ({}),
                        ajaxRequestFunc: createServiceTaskGenerationAwareAjaxRequest({
                            getBuildRequestParams,
                            fetchPaged: includeCrmTickets ? mergedListFetch : tabulatorGet,
                            inFlightRef,
                            completedCacheRef,
                            isRestoringRef,
                            lastResponseRef,
                            ajaxGenerationRef,
                            applyResponseOverlay: (response) => {
                                const next = applyPagedMutationOverlay(response, mutationOverlayRef.current);
                                if (next && typeof next === 'object') lastResponseRef.current = next;
                                return next;
                            },
                        }),
                        ajaxRequesting: () => {
                            if (tableBuiltRef.current && !isRestoringRef.current) captureHScroll();
                            const table = getTable();
                            if (table?.initialized) table.alert?.(t('ServiceTask.TableLoadingData'));
                            return true;
                        },
                        ajaxResponse: (url, params, response) => {
                            getTable()?.clearAlert?.();
                            if (response && typeof response === 'object') lastResponseRef.current = response;
                            return response;
                        },
                        ajaxError: () => {
                            getTable()?.clearAlert?.();
                        },
                        movableColumns: true,
                        headerSortTristate: true,
                        printAsHtml: true,
                        printHeader: () => buildCanonicalPrintHeaderHtml({
                          branding: state?.branding,
                          productFallbackSrc: defaultProductLogoSrc,
                          companySettingsPrint: state?.company_settings_print,
                          moduleSettings: state?.module_settings,
                          title: t('ServiceTaskAllList.Title'),
                          printDateLabel: t('Print.DateLabel'),
                        }),
                        printFooter: () => buildCanonicalPrintFooterHtml({ companySettingsPrint: state?.company_settings_print }),
                        printRowRange: "active",
                        autoResize: true,
                        scrollToColumnIfVisible: false,
                    }}
                    />
                    </div>
            </div>
            <Dialog header={t('Common.SearchInList')} visible={visibleSearch} style={{ width: '40vw' }} onHide={() => setVisibleSearch(false)}>
                <div className="flex flex-columns">
                    <input
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                        type="text"
                        className="block w-full px-4 py-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                    />
                    <button type="button" onClick={() => searchTable()} className="w-16 ml-8 px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600"><SearchIcon /></button>
                </div>
            </Dialog>
            <PrintOptionsDialog
                visible={printChoiceVisible}
                onHide={() => setPrintChoiceVisible(false)}
                orientation={printOrientationChoice}
                onOrientationChange={setPrintOrientationChoice}
                layout={printLayoutChoice}
                onLayoutChange={setPrintLayoutChoice}
                onConfirm={runServiceTaskAllPrint}
            />
            <TabulatorMaskDialog
                visible={maskVisible}
                onHide={() => setMaskVisible(false)}
                title={t('ServiceTask.SetMask')}
                fields={getMaskFields}
                checkedMap={columnsVisible}
                onToggleField={setMask}
                onSelectAll={() => changeMarkings(true)}
                onDeselectAll={() => changeMarkings(false)}
                onSave={() => {
                    const cols = { ...columnsVisible };
                    cols.status_indicator = true;
                    setUserMaskFilter('ServiceTaskAllList', 'set_columns', cols, null, null);
                    setMaskVisible(false);
                }}
                selectAllLabel={t('ServiceTask.SelectAll')}
                deselectAllLabel={t('ServiceTask.DeselectAllExceptId')}
                saveLabel={t('Common.Save')}
                getFieldLabel={(field) => getMaskColumnLabel(maskFieldToColumn[field] || { field })}
                inputIdPrefix="service-task-all-mask"
            />
        </>);
} 
